import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { marked } from 'marked';
import { CoacheeService } from 'src/app/core/services/coachee_services/coachee.service';
@Component({
  selector: 'app-coachee-dpa',
  templateUrl: './coachee-dpa.component.html',
})
export class CoacheeDpaComponent implements OnInit {

  consentHtml: string
  
  constructor(
    private coacheeService: CoacheeService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe((params) => {
      let lang = params['lang'] == 'de' ? 'de' : 'en';
      this.coacheeService.getActiveConsent('data-processing-agreement').subscribe((res) => {
        const text = res.text.find(text => text.locale === lang).text;
        this.consentHtml = marked.parse(text) as string;
      });
    });
  }
}
